import { views } from 'components/Lists/constants';

// Auth
export const currentUser = '/api/user/current';
export const logInUser = '/api/auth/login';
export const logInExternalUser = '/api/auth/external-login';
export const logOutUser = '/api/auth/logout';
export const verifyUserCode = '/api/auth/verify-code';
export const resetUserPassword = '/api/user/resetpassword';
export const completeReset = '/api/user/completereset';
export const completeSetPassword = '/api/user/complete-set-password';
export const failedLogin = '/api/user/failedlogin';
export const verifySetPasswordToken = token =>
  `/api/user/verify-set-password-token/${token}`;
export const passwordCheck = `/api/user/password-check`;
export const verifyResetPasswordToken = token =>
  `/api/user/verify-reset-password-token/${token}`;
export const refreshToken = '/api/auth/refresh-token';
export const oktaLogin = '/api/auth/sso-login';
export const checkSsoProviders = '/api/auth/sso-providers';

// Rate limits
export const resetRateLimits = '/api/rate-limits/reset';
// Search
export const organisationSearch = '/api/search/organisation';
export const organisationInsightsSearch = '/api/search/organisation/insights';
export const researcherSearch = '/api/search/researcher';
export const researcherHighlights = '/api/search/activity/highlights';
export const activitySearch = '/api/search/activity';
// export const researcherSearch = '/api/universal/search';
export const researcherGeoSearch = '/api/universal/geo-search';
export const organisationGeoSearch = '/api/search/organisation/geo';
export const addSearchToList = id =>
  `/api/researcherlist/${id}/members/fromsearch`;
export const addSearchToOrgList = id =>
  `/api/organisationlists/${id}/members/fromsearch`;
export const cancelSearch = '/api/search/cancel';

export const researchersLists = `/api/researcherlists/forresearchers`;
export const organisationsLists = `/api/organisationlists/formembers`;
export const exportSearch = '/api/universal/download';
export const checkExportSearch = '/api/universal/download/check';

export const largeWarning = downloadType =>
  `/api/user/largewarning?downloadType=${downloadType}`;

// Purchasing Search
export const purchasingSearch = '/api/purchasing-search';
export const exportPurchasing = '/api/purchasing-search/download';
export const exportOrganisationPurchasing =
  '/api/organisation-purchasing/download';

// Lists
export const getListsForUser = '/api/researcherlists/';
export const getCRMLists = '/api/researcherlists/crm';
export const getMembersForList = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/${id}/members`
    : `/api/organisationlists/${id}/members`;
export const researcherListPermissions = '/api/researcherlists/permissions';
export const organisationListPermissions = '/api/organisationlists/permissions';
export const disableList = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/${id}/disable`
    : `/api/organisationlists/${id}/disable`;
export const bulkDisableList = (view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/bulk-disable`
    : `/api/organisationlists/bulk-disable`;
export const enableList = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/${id}/enable`
    : `/api/organisationlists/${id}/enable`;
export const deleteList = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/${id}`
    : `/api/organisationlists/${id}`;
export const bulkDeleteList = (view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/bulk-delete`
    : `/api/organisationlists/bulk-delete`;
export const updateAccessLevels = id => `/api/researcherlist/${id}/settings`;
export const createList = (view = views.researchers) =>
  view === views.researchers ? '/api/researcherlist' : '/api/organisationlists';
export const updateList = (id, view = views.researchers) =>
  view === views.researchers
    ? '/api/researcherlist'
    : `/api/organisationlists/${id}`;
export const exportMembers = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/${id}/export`
    : `/api/organisationlists/${id}/export`;
export const manageMembers = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlist/${id}/members`
    : `/api/organisationlists/${id}/members`;
export const pushMembers = id => `/api/researcherlist/${id}/pushtocrm`;

export const getOrgListsForUser = '/api/organisationlists';

export const getPaginatedLists = (view = views.researchers) =>
  view === views.researchers
    ? '/api/researcherlists/search-paginated'
    : '/api/organisationlists/search-paginated';
export const getList = (id, view = views.researchers) =>
  view === views.researchers
    ? `/api/researcherlists/${id}`
    : `/api/organisationlists/${id}`;

// Researcher
export const getResearcher = '/api/researcher/profile';
export const unfollowResearcher = '/api/alert/unfollow';
export const bulkUnfollowResearcher = '/api/alert/bulk-unfollow';
export const reportResearcher = '/api/researcher/report';
export const exportNetwork = '/api/researcher/network';
export const searchByFullName = '/api/universal/filter/searchbar';

export const allExportHistory = '/api/exportHistory/all';
export const refreshExportHistory = id => `/api/exportHistory/${id}`;
export const getUserCredits = '/api/user/getCredits';

// Export Templates
export const exportTemplates = '/api/export-templates';
export const exportTemplatesMinimalList = '/api/export-templates/minimal-list';
export const exportTemplatesSearch = '/api/export-templates/search';
export const exportTemplatesMetadata = '/api/export-templates/metadata';
export const exportTemplate = id => `/api/export-templates/${id}`;
export const exportTemplatesBulkDelete = '/api/export-templates/bulk-delete';

//Organisation
export const getSuperOrganisation = id => `/api/superorganisation/${id}`;
export const searchSuperOrganisationResearchers = id =>
  `/api/search/organisation/${id}/researcher`;
export const unfollowOrganisation = '/api/organisation_alert/unfollow';
export const bulkUnfollowOrganisation = '/api/organisation_alert/bulk-unfollow';
export const searchSuperOrganisationWorkItems = id =>
  `/api/search/organisation/${id}/workitems`;
export const searchSuperOrganisationClinicalTrials = id =>
  `/api/search/organisation/${id}/clinicaltrials`;
export const reportOrganisation = '/api/superorganisation/report';
export const superOrganisationsExists = `/api/superorganisation/existsuperorgidsinindex`;
export const exportVcFunding = id =>
  `/api/superorganisation/${id}/vc-funding-export`;
export const exportSubsidiaries = id =>
  `/api/superorganisation/${id}/subsidiaries-export`;

// Alerts
export const userAlerts = '/api/alert';
export const sanityCheckAlert = '/api/alert/sanityCheck';

export const userOrganisationAlerts = '/api/organisation_alert';
export const userFollowedResearchers = '/api/alert/followedResearchers';
export const userFollowedOrganisations =
  '/api/organisation_alert/followedOrganisations';

// Calendar
export const tradeshowCalendar = '/api/trade-shows/calendar';
export const tradeshowCalendarYears = '/api/trade-shows/years';
export const requestTradeshow = '/api/trade-shows/request';
export const tradeshowNames = '/api/universal/filter/tradeshow-names/';
export const tradeshowDownload = '/api/tradeshow/download';
export const tradeshowCalendarDownload = '/api/tradeshow/calendar/download';
export const researcherTradeshows = researcherId =>
  `/api/trade-shows/by-researcher/${researcherId}`;

// AI
export const aiMessage = '/api/ai/message';
export const aiMessageInteraction = '/api/ai/messageInteraction';
export const generateFilters = '/api/ai/filters';
export const generateFollowUps = '/api/ai/followups';
export const aiSearchFeedback = '/api/ai/search_feedback';
export const aiSynonymSelections = '/api/ai/synonym_selections';
export const aiRecentSearches = '/api/ai/recent-searches';
/** Remaining AI search credits for the current user (`{ remaining }` only). */
export const aiSearchCredits = '/api/ai/search-credits';
/** Lightweight index of ALL examples across all views (id + prompt + viewName); FE filters by current view for pills. */
export const aiNlpSearchExamplesAll = '/api/ai/search-examples/all';
/** Full example detail (filters + live-derived termSynonyms/termPlurals). */
export const aiNlpSearchExampleById = id => `/api/ai/search-examples/${id}`;
export const aiSearchHistoryLookup = '/api/ai/search-history-lookup';
/** POST body: curated example restore (no /filters) — persists a history row. */
export const aiRecordSearchHistory = '/api/ai/search-history';
export const aiSearchHistoryPin = id => `/api/ai/search-history/${id}/pin`;
export const aiSearchHistoryUse = id => `/api/ai/search-history/${id}/use`;
export const aiSearchHistoryDelete = id => `/api/ai/search-history/${id}`;
/** Org-scoped SciSearch AI filter generation. Same request/response shape as
 * `generateFilters`, plus server-side scoping to the organisation. */
export const aiOrganisationFilters = organisationId =>
  `/api/ai/organisation/${organisationId}/filters`;
/** Org-scoped recent SciSearch AI searches (server-provided; not the localStorage recents). */
export const aiOrganisationRecentSearches = organisationId =>
  `/api/ai/organisation/${organisationId}/recent`;

// Project
export const getProject = id => `/api/project/${id}`;
export const findEmail = '/api/finder';

// Poster
export const getPoster = '/api/trade-shows/poster';

// Publication
export const getPublication = '/api/pubmed/item';
export const getKeywords = '/api/pubmed/item/keywords';

// Trial
export const getTrial = '/api/clinicaltrials/trial';

// Item
export const getItem = id => `/api/purchasing/item/${id}`;

// Settings
// // My Account
export const autoRenew = '/api/settings/autorenew';
export const toggleAutoRenew = '/api/account/license/autorenew';
export const updateUser = '/api/user/update';
export const changePassword = '/api/user/changepassword';
// // CRM Integrations
export const getSalesforceData = '/api/crm/settings/Salesforce';
export const saveSalesforceData = '/api/crm/settings/Salesforce';
export const disconnectSalesforce = '/api/settings/crmlogout/Salesforce';
export const crmSettings = '/api/crm/settings';
export const getHubSpotData = '/api/crm/settings/Hubspot';
export const saveHubSpotData = '/api/crm/settings/Hubspot';
export const disconnectHubSpot = '/api/settings/crmlogout/Hubspot';
export const getDynamicsData = '/api/crm/settings/Dynamics';
export const saveDynamicsData = '/api/crm/settings/Dynamics';
export const disconnectDynamics = '/api/settings/crmlogout/Dynamics';
export const setDynamicsInstance = '/api/crm/settings/Dynamics/instance';
// // User Management
export const allUsers = '/api/account/users/all';
export const allUserAccounts = '/api/account/users/allUserAccounts';

export const allUsersIncludeInactive =
  '/api/account/users/all?includeInactive=true';
export const editUser = '/api/account/users/update';
export const createUser = '/api/account/users/create';
export const toggleUser = '/api/account/users/changestatus';
export const resetPassword = '/api/account/users/passwordreset';
export const toggleTradeshowRequester =
  '/api/account/users/toggletradeshowrequester';
export const toggleCanPushToSalesforce =
  '/api/account/users/togglecanpushtosalesforce';
export const toggleCanPushToHubspot =
  '/api/account/users/togglecanpushtohubspot';
export const toggleCanPushToDynamics =
  '/api/account/users/togglecanpushtodynamics';
export const toggleUserManager = '/api/account/users/toggleusermanager';

// Account Products
export const listAccountProducts = '/api/Account/Products';
export const createAccountProduct = '/api/Account/Products';
export const editAccountProduct = id => `/api/Account/Products/${id}`;
export const setAccountProductActive = id =>
  `/api/Account/Products/${id}/active`;
export const reorderAccountProducts = '/api/Account/Products/reorder';

// User Settings
export const userSettings = '/api/userSettings';

// // User Report
export const userReport = '/api/account/users/report/';
export const userSearchHistoryReport = '/api/account/users/historyReport/';
export const userSearchHistoryReportExport =
  '/api/account/users/historyReportExport';

// // Keyword Management
export const userKeywords = '/api/settings/keywords';
export const userHasKeywords = '/api/settings/keywords/exist';

// // Email Request
export const emailRequests = '/api/email-requests';
// Live Chat
export const chatOpen = '/api/user/livehelp/open';
export const chatClose = '/api/user/livehelp/close';

// Logging
export const log = '/api/log/ui';

// SF Enquiry
export const salesEnquiry = '/api/enquiry';

// Downloads
export const downloadExport = id => `/api/downloads/ui/${id}`;

// NPS
export const netPromoterScorePrompt = '/api/nps/net-promotor-score-prompt';
export const netPromoterScore = '/api/nps/net-promoter-score';

// Enrichment
export const enrichmentStatus = dataEnrichmentId =>
  `/api/enrichment/status/${dataEnrichmentId}`;
export const enrichmentSummary = dataEnrichmentId =>
  `/api/enrichment/summary/${dataEnrichmentId}`;
export const enrichResearchers = '/api/enrichment/researchers';
export const enrichOrganisations = '/api/enrichment/organisations';
export const dataEnrichmentTable = '/api/enrichment/table';
export const getDataEnrichment = id => `/api/enrichment/${id}`;
export const downloadEnrichment = id => `/api/enrichment/${id}/download`;
export const getCredits = '/api/enrichment/credits';
